import { useMutation } from "@apollo/client";

import { GqlPlannerAreaMediaAudience } from "~/__generated__";

import { MapEditorPlannerAreaPanel_PlannerAreaMediaAddMediaDocument } from "../../mutations.generated";
import { MapEditorPlannerAreaPanelDocument } from "../../queries.generated";

export function useAddPlannerAreaMediaMutation() {
    const [mutate, result] = useMutation(MapEditorPlannerAreaPanel_PlannerAreaMediaAddMediaDocument, {
        refetchQueries: [MapEditorPlannerAreaPanelDocument],
    });

    const addPlannerAreaMedia = (plannerAreaId: string, mediaIds: string[], audience: GqlPlannerAreaMediaAudience) =>
        mutate({
            variables: { input: { plannerAreaId, mediaIds, audience } },
        });

    return [addPlannerAreaMedia, result] as const;
}
